<footer class="bg-white">
  <div class="mx-auto w-full max-w-screen-xl p-4 py-6 lg:py-8">
    <div class="md:flex md:justify-between">
      <div class="mb-6 md:mb-0">
        <a [routerLink]="RouteLocations.Home.absoluteUrl"
           [queryParams]="homeQueryParams"
           class="flex items-center"
        >
          <app-logo [priority]="true" />
        </a>
      </div>
      <div class="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
        <div>
          <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">Follow us</h2>
          <ul class="text-gray-500 font-medium">
            <li>
              <a [href]="patreonLink" target="_blank" class="hover:underline">Patreon</a>
            </li>
            <li class="mt-3">
              <a [href]="discordLink" target="_blank" class="hover:underline">Discord</a>
            </li>
          </ul>
        </div>
        <div>
          <h2 class="mb-6 text-sm font-semibold text-gray-900 uppercase">Legal</h2>
          <ul class="text-gray-500 font-medium">
            <li>
              <a [routerLink]="RouteLocations.PrivacyPolicy.absoluteUrl" class="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li class="mt-3">
              <a [routerLink]="RouteLocations.TermsAndConditions.absoluteUrl" class="hover:underline">
                Terms &amp; Conditions
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto lg:my-8" />
    <div class="text-center sm:flex sm:items-center sm:justify-between">
      <span class="text-sm text-gray-500 sm:text-center"
        >© {{ year }} RPG Bench™. All Rights Reserved.
      </span>
      <div class="flex mt-4 justify-center sm:mt-0">
        <a [href]="patreonLink" target="_blank" class="text-gray-500 hover:text-gray-900 ms-5">
          <fa-icon [icon]="faPatreon" />
        </a>
        <a [href]="discordLink" target="_blank" class="text-gray-500 hover:text-gray-900 ms-5">
          <fa-icon [icon]="faDiscord" />
        </a>
      </div>
    </div>
  </div>
</footer>
